import {Nullish} from 'shared/web';

/**
 * @description These props are used ONLY for internal control of the Lightbox component.
 * We do not recommend using them in the application.
 */
export type InternalLightboxControls = {
  /**
   * @description Registration id that identifies a specific lightbox and is only required param of the useLightbox hook
   */
  passedLightboxId: string;
  /**
   * @description Id is used to identify a specific Lightbox it is required prop
   */
  lightboxId: string | Nullish;
  /**
   * @description Represents the index of the currently active slide in Slideshow
   * @returns {number}
   * @default 0
   */
  initialIndex: number;
  /**
   * @description This option determines whether GridView is enabled in the lightbox
   * @returns {boolean}
   */
  isGridViewEnabled: boolean;
  /**
   * @description Grid can be zoomed in and out...the scale represents the total number of the displayed items in the row
   */
  gridScale: number;
  /**
   * @description Represents the index of the currently active detail's slide in the Lightbox
   * @returns {number|Nullish}
   */
  activeDetailIndex: number | Nullish;
  /**
   * @description Switch between grid view and lightbox view
   */
  onViewChange: () => void;
  /**
   * @description changes the number of items in the grid
   * @param {number} scale - Grid can be zoomed in and out... the scale represents the total number of the displayed items in the row
   */
  onGridScaleChange: (scale: number) => void;
  /**
   * @description It opens the detail of the slide and sets its index
   * as the activeIndex and activeDetailIndex to the queryParams
   * @param {number} index - Index of the currently active detail
   */
  onDetailOpen: (index: number) => void;
  /**
   * @description The 'onDetailOpen' action it returns the user back from the detail to the overview of slides
   * in the Slideshow lightbox and removes the activeDetailIndex from the query parameters.
   * @param {number} activeIndex - Index of the currently active detail
   */
  onDetailClose: (activeIndex: number) => void;
  /**
   * @description The 'onClose' action closes the entire lightbox and clears all the queryParams
   */
  onClose: () => void;
};
